import './team.scss';
import Renjie from './Renjie';
import Weixian from './Weixian';

function Team() {
  return (
    <div className="team">
      <div className="innerTeam">
        <Renjie />
        <div className="vl">
          <div className="bk"></div>
          <div className="divider"></div>
        </div>
        <Weixian />
      </div>
      <div className="axolotl"></div>
    </div>
  );
}

export default Team;
